export default "__VITE_ASSET__BMPWsehk__"